import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebaseConfig";
import LatestSidebar from "../Components/LatestSidebar";
import { FaCalendarAlt, FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";

const Archive = () => {
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [version, setVersion] = useState("");

  const [allNews, setAllNews] = useState([]);
  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);

  const isMobile = window.innerWidth <= 768;

  // -----------------------------
  // সব নিউজ একবার আনা
  // -----------------------------
  useEffect(() => {
    const fetchNews = async () => {
      try {
        const q = query(
          collection(db, "news"),
          orderBy("timestamp", "desc")
        );

        const snapshot = await getDocs(q);

        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setAllNews(data);
      } catch (error) {
        console.error("Archive news fetch error:", error);
      }
    };

    fetchNews();
  }, []);

  // -----------------------------
  // Archive Search
  // -----------------------------
  const handleSearch = () => {
    setLoading(true);
    setSearched(true);

    // এখন শুধু Online news filter হবে
    if (version === "print") {
      setResults([]);
      setLoading(false);
      return;
    }

    let filtered = [...allNews];

    // দিন + মাস + বছর অথবা শুধু বছর দিয়ে filter
    if (day && month && year) {
      filtered = filtered.filter((item) => {
        if (!item.timestamp) return false;

        const d = item.timestamp.toDate
          ? item.timestamp.toDate()
          : new Date(item.timestamp);

        return (
          String(d.getDate()).padStart(2, "0") === day &&
          String(d.getMonth() + 1).padStart(2, "0") === month &&
          String(d.getFullYear()) === year
        );
      });
    } else if (year) {
      filtered = filtered.filter((item) => {
        if (!item.timestamp) return false;

        const d = item.timestamp.toDate
          ? item.timestamp.toDate()
          : new Date(item.timestamp);

        return String(d.getFullYear()) === year;
      });
    }

    setResults(filtered);
    setLoading(false);
  };

  const currentYear = new Date().getFullYear();
  const years = [];

  for (let y = 2026; y <= currentYear; y++) {
    years.push(y);
  }

  years.reverse();

  return (
    <div
      style={{
        maxWidth: "1400px",
        margin: "0 auto",
        padding: "0 10px",
      }}
    >
      {/* =========================
          Archive Header
      ========================== */}
      <div
        style={{
          borderLeft: "5px solid #d2202a",
          paddingLeft: "15px",
          marginBottom: "6px",
        }}
      >
        <h2
          style={{
            fontSize: "25px",
            fontWeight: "bold",
            color: "#333",
            margin: 0,
          }}
        >
          আর্কাইভ
        </h2>
      </div>

      {/* =========================
          Main + Sidebar
      ========================== */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: "25px",
          alignItems: "flex-start",
        }}
      >
        {/* =========================
            LEFT
        ========================== */}
        <main
          style={{
            flex: 1,
            width: isMobile ? "100%" : "auto",
            minWidth: 0,
          }}
        >

            {/* All inputs and search button in one single row */}
          <div
  style={{
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    alignItems: "center",
  }}
>
              {/* দিন */}
              <div style={{ flex: "1 1 120px" }}>
          
                <select
                  value={day}
                  onChange={(e) => setDay(e.target.value)}
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "14px",
                    background: "#fff",
                  }}
                >
                  <option value="">দিন</option>
                  {Array.from({ length: 31 }, (_, i) => {
                    const d = String(i + 1).padStart(2, "0");
                    return (
                      <option key={d} value={d}>
                        {d}
                      </option>
                    );
                  })}
                </select>
              </div>

              {/* মাস */}
              <div style={{ flex: "1 1 140px" }}>
               
                <select
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "14px",
                    background: "#fff",
                  }}
                >
                  <option value="">মাস</option>
                  <option value="01">জানুয়ারি</option>
                  <option value="02">ফেব্রুয়ারি</option>
                  <option value="03">মার্চ</option>
                  <option value="04">এপ্রিল</option>
                  <option value="05">মে</option>
                  <option value="06">জুন</option>
                  <option value="07">জুলাই</option>
                  <option value="08">আগস্ট</option>
                  <option value="09">সেপ্টেম্বর</option>
                  <option value="10">অক্টোবর</option>
                  <option value="11">নভেম্বর</option>
                  <option value="12">ডিসেম্বর</option>
                </select>
              </div>

              {/* বছর */}
              <div style={{ flex: "1 1 120px" }}>
                
                <select
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "14px",
                    background: "#fff",
                  }}
                >
                  <option value="">বছর</option>
                  {years.map((y) => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  ))}
                </select>
              </div>

              {/* সংস্করণ */}
              <div style={{ flex: "1 1 160px" }}>
               
                <select
                  value={version}
                  onChange={(e) => setVersion(e.target.value)}
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "14px",
                    background: "#fff",
                  }}
                >
                  <option value="">সংস্করণ নির্বাচন</option>
                  <option value="online">অনলাইন সংস্করণ</option>
                  <option value="print">প্রিন্ট সংস্করণ</option>
                </select>
              </div>

              {/* Search Button */}
              <div>
               <button
  type="button"
  onClick={handleSearch}
  style={{
    padding: "10px 25px",
    background: "#d2202a",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: "bold",
    cursor: "pointer",
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "7px",
    height: "41px",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 5px rgba(0,0,0,0.12)",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.background = "#b51b24";
    e.currentTarget.style.transform = "translateY(-2px)";
    e.currentTarget.style.boxShadow =
      "0 5px 10px rgba(0,0,0,0.18)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = "#d2202a";
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow =
      "0 2px 5px rgba(0,0,0,0.12)";
  }}
  onMouseDown={(e) => {
    e.currentTarget.style.transform = "translateY(1px)";
  }}
  onMouseUp={(e) => {
    e.currentTarget.style.transform = "translateY(-2px)";
  }}
>
  <FaSearch />
  খুঁজুন
</button>
              </div>
          
          </div>

          {/* =========================
              Results
          ========================== */}
         <div>
  <h3
    style={{
      margin: "0 0 18px",
      fontSize: "21px",
      color: "#333",
    }}
  >
    আর্কাইভ ফলাফল
  </h3>

            {!searched && (
              <div
                style={{
                  padding: "50px 20px",
                  textAlign: "center",
                  border: "1px solid #eee",
                  color: "#777",
                }}
              >
                তারিখ ও সংস্করণ নির্বাচন করে খুঁজুন
              </div>
            )}

            {searched && loading && (
              <div
                style={{
                  padding: "50px 20px",
                  textAlign: "center",
                  color: "#777",
                }}
              >
                লোড হচ্ছে...
              </div>
            )}

            {searched && !loading && version === "print" && (
              <div
                style={{
                  padding: "50px 20px",
                  textAlign: "center",
                  border: "1px solid #eee",
                  color: "#777",
                }}
              >
                প্রিন্ট সংস্করণের আর্কাইভ শিগগিরই এখানে দেখানো হবে।
              </div>
            )}

      
{/* =========================
    No Results
========================= */}

{searched &&
  !loading &&
  version !== "print" &&
  results.length === 0 && (
    <div
      style={{
        padding: "50px 20px",
        textAlign: "center",
        border: "1px solid #eee",
        color: "#777",
      }}
    >
      কোনো সংবাদ পাওয়া যায়নি।
    </div>
  )}

{/* =========================
    Category Wise Results
========================= */}

{searched &&
  !loading &&
  version === "online" &&
  results.length > 0 &&
  (() => {
    const groupedNews = results.reduce((groups, item) => {
      const category = item.category || "অন্যান্য";

      if (!groups[category]) {
        groups[category] = [];
      }

      groups[category].push(item);

      return groups;
    }, {});

    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
          gap: "20px",
        }}
      >
        {Object.entries(groupedNews).map(
          ([category, categoryNews]) => (
            <div
              key={category}
              style={{
                background: "#fff",
                border: "1px solid #ddd",
                borderRadius: "4px",
                overflow: "hidden",
              }}
            >
              {/* Category Header */}
              <div
                style={{
                  padding: "10px 15px",
                  background: "#f7f7f7",
                  borderBottom: "3px solid #d2202a",
                  fontSize: "19px",
                  fontWeight: "700",
                  color: "#000000",
                }}
              >
                {category}
              </div>

         
{/* Headlines */}
<div
  style={{
    padding: "3px 15px",
  }}
>
  {categoryNews.map((item, index) => (
    <Link
      key={item.id}
      to={`/${item.categorySlug || "news"}/${item.subcategorySlug || "all"}/${item.id}`}
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "7px",
        padding: "5px 0",
        borderBottom:
          index < categoryNews.length - 1
            ? "1px solid #eee"
            : "none",
        color: "#000000",
        textDecoration: "none",
        fontSize: "16px",
        lineHeight: "1.4",
        transition: "color 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "#4169E1";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "#222";
      }}
    >
      {/* Red Circle */}
      <span
        style={{
          width: "6px",
          height: "6px",
          minWidth: "6px",
          marginTop: "8px",
          borderRadius: "50%",
          background: "#d2202a",
        }}
      />

      <span>{item.title}</span>
    </Link>
  ))}
</div>


            </div>
          )
        )}
      </div>
    );
  })()}
      </div>
    </main>


        {/* =========================
            RIGHT SIDEBAR
        ========================== */}
        {!isMobile && (
          <aside
            style={{
              width: "300px",
              flexShrink: 0,
            }}
          >
            <LatestSidebar />
          </aside>
        )}
      </div>
    </div>
  );
};

export default Archive;